var exports = {
  "f": "tableLayoutFixed__jbqGYz",
  "o": "compact__Uz2RkM",
};

module.exports = exports;
